export default __webpack_public_path__ + "f49cf37b98fd39330851c360c6cacc23.jpg";